import { type Command } from '@telespot/core';

/**
 * @group Protocols
 * @category Payloads
 */
export interface ListAlgorithmUsageDetails {
  /**
   * The id of the algorithm to list the usage of.
   */
  algorithmId: string;

  /**
   * The batch size for the listing.
   * Indicates the number of parallel calls to the database that can be made.
   */
  batchSize: number;
}

/**
 * Command registration token for {@link ListAlgorithmUsage}
 *
 * @group Protocols
 * @category Tokens
 */
export const LIST_ALGORITHM_USAGE = 'protocols:listAlgorithmUsage';

/**
 * Lists the usage of an algorithm.
 */
export class ListAlgorithmUsage implements Command<typeof LIST_ALGORITHM_USAGE, ListAlgorithmUsageDetails> {
  public readonly name = LIST_ALGORITHM_USAGE;
  constructor(public readonly details: ListAlgorithmUsageDetails) {}
}
